<template>
  <v-layout class="on-white-background" row wrap style="margin-left:-8px; margin-right:-8px;">
    <v-flex xs12>
      <h2 class="primary--text pb-2">Teams</h2>
    </v-flex>
    <v-flex>
      <v-container fluid ma-0 pa-0>
        <v-layout wrap class="card-margin-fix">
          <team-card
v-for="(item, i) in user.teams" :key="i"
            :cardContent="item"
            :cardIndex="i"
            :cardOwner="user"
            cardAction="remove">
            </team-card>
        </v-layout>
        <br>
        <h2 class="primary--text pb-3 pt-2">Add to new team</h2>
        <v-layout wrap class="card-margin-fix">
          <team-card
v-for="(item, i) in getSelectedUsersFilteredTeams" :key="i"
            :cardContent="item"
            :cardIndex="i"
            cardAction="add">
          </team-card>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import '@/assets/styles/styles.css'
import { mapState } from 'vuex'
import TeamCard from '@/components/teams/TeamCard.vue'

export default {
  name: 'user-edit-teams',
  components: { TeamCard },
  computed: {
    ...mapState({
      user: state => state.users.currentlySelected.user,
      userTeams: state => state.users.currentlySelected.user.teams,
      teams: state => state.teams.all
    }),
    getSelectedUsersFilteredTeams() {
      if (this.userTeams) {
        const currentTeamIds = this.userTeams.map(team => team.id)
        return this.teams.filter(function(team) { return (this.indexOf(team.id) < 0) }, currentTeamIds)
      } else {
        return []
      }
    }
  }
}
</script>
